import Header from '@/components/header/Header.vue';
import Footer from '@/components/footer/Footer.vue';
import axios from '@/config/axios';

export default {
  name: 'OldBookDetail',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      booth: null,
      activeImage: null,
      activeKey: null,
      activeBookItem: null,
      isLoading: true,
      
      // Multi-Book Selection for Cart
      selectedBookKeys: [],

      // Zoom Modal State
      showZoomModal: false,
      zoomScale: 1,
      zoomPanX: 0,
      zoomPanY: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      toolbarHidden: false,

      // Contact / Order Modal State
      showContactModal: false,
      selectedBookForContact: null,
      contactPhone: '',
      contactAddress: '',
      contactNote: '',
      isSendingContact: false
    };
  },
  computed: {
    isLoggedIn() {
      return !!localStorage.getItem('token');
    },
    currentUserId() {
      try {
        const raw = localStorage.getItem('current-account');
        if (raw) {
          const acc = JSON.parse(raw);
          return acc.id || acc.userId || null;
        }
      } catch (e) {
        console.error(e);
      }
      return null;
    },
    isMyBooth() {
      if (!this.booth) return false;
      if (this.booth.isMyBooth === true) return true;
      if (this.currentUserId && this.booth.createBy && String(this.currentUserId) === String(this.booth.createBy)) {
        return true;
      }
      return false;
    },
    isOwner() {
      return this.isMyBooth;
    },
    isAllBooksSelected() {
      return !!(this.booth && this.booth.books && this.booth.books.length > 0 && this.selectedBookKeys.length === this.booth.books.length);
    },
    selectedBooksCount() {
      return this.selectedBookKeys.length;
    },
    selectedBooksList() {
      if (!this.booth || !this.booth.books) return [];
      return this.booth.books.filter((b, idx) => this.selectedBookKeys.includes(this.getBookKey(b, idx)));
    },
    selectedBooksTotalPrice() {
      if (!this.booth || !this.booth.books) return 0;
      if (this.isAllBooksSelected) {
        return Number(this.booth.price) || 0;
      }
      const avgPrice = Math.round(this.booth.price / (this.booth.books.length || 1));
      return this.selectedBooksList.reduce((sum, b) => {
        const p = (this.booth.saleType === 0 && b.price) ? Number(b.price) : avgPrice;
        return sum + (p || 0);
      }, 0);
    },
    cartItems() {
      return this.$store.getters['cart/cartItems'] || [];
    },
    isBoothInCart() {
      if (!this.booth) return false;
      const cart = this.cartItems;
      const hasWholeBooth = cart.some(i => i.id === `booth_${this.booth.id}`);
      if (hasWholeBooth) return true;
      if (this.booth.books && this.booth.books.length > 0) {
        return this.booth.books.every((b, idx) => {
          const bookKey = this.getBookKey(b, idx);
          return cart.some(i => i.id === `book_${this.booth.id}_${bookKey}`);
        });
      }
      return false;
    },
    unaddedSelectedBooks() {
      return this.selectedBooksList.filter((book, idx) => !this.isBookInCart(book, idx));
    },
    unaddedSelectedBooksCount() {
      return this.unaddedSelectedBooks.length;
    },
    isAllSelectedBooksInCart() {
      if (this.selectedBooksList.length === 0) return false;
      if (this.isAllBooksSelected && this.isBoothInCart) return true;
      return this.unaddedSelectedBooksCount === 0;
    },
    activeImageLabel() {
      if (!this.activeKey) {
        if (this.booth && this.booth.books && this.booth.books.length === 1) {
          return 'Cuốn 1 - Bìa trước';
        }
        return '';
      }
      if (this.activeKey === 'stack') return 'Ảnh chụp chồng sách';
      if (this.activeKey.startsWith('book_')) {
        const parts = this.activeKey.split('_'); // ['book', index, 'cover' or 'coverBack']
        const idx = parseInt(parts[1], 10);
        const type = parts[2];
        const bookNum = !isNaN(idx) ? (idx + 1) : 1;
        const sideText = type === 'coverBack' ? 'Bìa sau' : 'Bìa trước';
        return `Cuốn ${bookNum} - ${sideText}`;
      }
      if (this.activeKey === 'coverImage') return 'Ảnh bìa gian hàng';
      return '';
    }
  },
  watch: {
    showZoomModal(open) {
      if (open) {
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', this.handleZoomKeydown);
      } else {
        document.body.style.overflow = '';
        window.removeEventListener('keydown', this.handleZoomKeydown);
      }
    }
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.fetchBoothDetail(id);
    }
  },
  methods: {
    fetchBoothDetail(id) {
      this.isLoading = true;
      axios.get(`/old-book/v1/detail/${id}`)
        .then(res => {
          if (res.data.status === '200' && res.data.result) {
            const data = res.data.result;
            
            const isValidImg = (val) => {
              if (!val || typeof val !== 'string') return false;
              const trimmed = val.trim();
              if (
                trimmed === '' || 
                trimmed === 'null' || 
                trimmed === 'undefined' || 
                trimmed === 'NaN' || 
                trimmed === 'none' ||
                trimmed === 'null,null' ||
                trimmed === 'data:image/png;base64,' ||
                trimmed === 'data:image/jpeg;base64,' ||
                trimmed === 'data:,' ||
                trimmed.length < 5
              ) {
                return false;
              }
              return true;
            };

            if (!isValidImg(data.stackImage)) {
              data.stackImage = null;
            } else if (!data.stackImage.startsWith('data:') && !data.stackImage.startsWith('http')) {
              data.stackImage = 'data:image/png;base64,' + data.stackImage;
            }

            if (!isValidImg(data.coverImage)) {
              data.coverImage = null;
            } else if (!data.coverImage.startsWith('data:') && !data.coverImage.startsWith('http')) {
              data.coverImage = 'data:image/png;base64,' + data.coverImage;
            }

            if (data.books && Array.isArray(data.books)) {
              data.books.forEach(b => {
                ['cover', 'coverBack'].forEach(k => {
                  if (!isValidImg(b[k])) {
                    b[k] = null;
                  } else if (!b[k].startsWith('data:') && !b[k].startsWith('http')) {
                    b[k] = 'data:image/png;base64,' + b[k];
                  }
                });
              });
            }

            this.booth = data;
            
            // Set initial active image (priority: stackImage only if present -> book cover -> coverImage)
            if (data.stackImage && isValidImg(data.stackImage)) {
              this.activeImage = data.stackImage;
              this.activeBookItem = null;
              this.activeKey = 'stack';
            } else if (data.books && data.books.length > 0 && data.books[0].cover) {
              this.activeImage = data.books[0].cover;
              this.activeBookItem = data.books[0];
              this.activeKey = 'book_0_cover';
            } else if (data.books && data.books.length > 0 && data.books[0].coverBack) {
              this.activeImage = data.books[0].coverBack;
              this.activeBookItem = data.books[0];
              this.activeKey = 'book_0_coverBack';
            } else {
              this.activeImage = data.coverImage || null;
              this.activeBookItem = null;
              this.activeKey = null;
            }
          } else {
            this.booth = null;
          }
        })
        .catch(err => {
          console.error(err);
          this.booth = null;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    setActiveMedia(img, book, key) {
      if (!img) return;
      this.activeImage = img;
      this.activeBookItem = book || null;
      this.activeKey = key || null;
    },
    scrollThumbs(direction) {
      const container = this.$refs.thumbStrip;
      if (!container) return;
      const scrollAmount = direction === 'left' ? -220 : 220;
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    },
    handleThumbWheel(e) {
      const container = this.$refs.thumbStrip;
      if (!container) return;
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
        container.scrollLeft += e.deltaY;
      }
    },
    openZoomForBook(img, book, key) {
      if (img) {
        this.activeImage = img;
        this.activeBookItem = book || null;
        if (key) this.activeKey = key;
      }
      this.openZoomModal();
    },
    goToEdit() {
      if (this.booth && this.booth.id) {
        this.$router.push('/old-books/edit/' + this.booth.id);
      }
    },
    changeBoothStatus(newStatus) {
      if (!this.booth || !this.booth.id) return;
      axios.put(`/old-book/status/${this.booth.id}`, { status: newStatus })
        .then(res => {
          if (res.data.status === '200') {
            this.$toast.success('Cập nhật trạng thái gian hàng thành công!');
            this.booth.status = newStatus;
          } else {
            this.$toast.error(res.data.message || 'Cập nhật thất bại');
          }
        })
        .catch(err => {
          console.error(err);
          this.$toast.error('Lỗi khi cập nhật trạng thái');
        });
    },
    handleBuyBooth() {
      if (!this.booth) return;

      if (this.isMyBooth) {
        this.$toast.warning('Bạn không thể tự mua gian hàng sách của chính mình!');
        return;
      }

      if (this.isBoothInCart) {
        this.$toast.info(`Gian hàng / Combo "${this.booth.name}" đã có trong giỏ hàng của bạn!`);
        this.$store.dispatch('cart/openDrawer');
        return;
      }

      const item = {
        id: `booth_${this.booth.id}`,
        boothId: this.booth.id,
        boothName: this.booth.name,
        sellerId: this.booth.createBy,
        sellerName: this.booth.createByName,
        saleType: this.booth.saleType,
        type: this.booth.saleType === 1 ? 'COMBO' : 'BOOTH',
        name: this.booth.name,
        cover: this.booth.stackImage || this.booth.coverImage || (this.booth.books && this.booth.books[0] && this.booth.books[0].cover),
        price: this.booth.price,
        weight: this.booth.weight || 350,
        totalBooks: this.booth.totalBooks,
        perStatus: this.booth.books && this.booth.books.length === 1 ? this.booth.books[0].perStatus : null,
        verStatus: this.booth.books && this.booth.books.length === 1 ? this.booth.books[0].verStatus : null
      };
      this.$store.dispatch('cart/addToCart', { item, openDrawer: true });
      this.$toast.success(
        this.booth.saleType === 1
          ? `Đã thêm combo "${this.booth.name}" vào giỏ hàng!`
          : `Đã thêm gian hàng "${this.booth.name}" vào giỏ hàng!`
      );
    },
    handleBuySingleBook(book, index) {
      if (!book || !this.booth) return;

      if (this.isMyBooth) {
        this.$toast.warning('Bạn không thể tự mua sách của chính mình!');
        return;
      }

      if (this.isBookInCart(book, index)) {
        this.$toast.info(`Cuốn sách "${book.name}" đã có trong giỏ hàng của bạn!`);
        this.$store.dispatch('cart/openDrawer');
        return;
      }

      const bookKey = this.getBookKey(book, index);
      const item = {
        id: `book_${this.booth.id}_${bookKey}`,
        boothId: this.booth.id,
        boothName: this.booth.name,
        bookId: book.id || book.idBook,
        sellerId: this.booth.createBy,
        sellerName: this.booth.createByName,
        saleType: this.booth.saleType,
        type: 'SINGLE',
        name: book.name,
        author: book.author,
        cover: book.cover || book.coverBack,
        price: book.price || Math.round(this.booth.price / (this.booth.books ? this.booth.books.length : 1)),
        weight: book.weight || (this.booth.weight && this.booth.books ? Math.round(this.booth.weight / this.booth.books.length) : 250),
        perStatus: book.perStatus,
        verStatus: book.verStatus
      };
      this.$store.dispatch('cart/addToCart', { item, openDrawer: true });
      this.$toast.success(`Đã thêm "${book.name}" vào giỏ hàng!`);
    },
    getBookKey(book, index) {
      return (book && (book.id || book.idBook)) ? String(book.id || book.idBook) : ('book_idx_' + index);
    },
    isBookInCart(book, index) {
      if (!this.booth || !book) return false;
      const cart = this.cartItems;
      const hasWholeBooth = cart.some(i => i.id === `booth_${this.booth.id}`);
      if (hasWholeBooth) return true;
      const bookKey = this.getBookKey(book, index);
      return cart.some(i => i.id === `book_${this.booth.id}_${bookKey}`);
    },
    isBookSelected(book, index) {
      return this.selectedBookKeys.includes(this.getBookKey(book, index));
    },
    toggleBookSelection(book, index) {
      const key = this.getBookKey(book, index);
      const idx = this.selectedBookKeys.indexOf(key);
      if (idx > -1) {
        this.selectedBookKeys.splice(idx, 1);
      } else {
        this.selectedBookKeys.push(key);
      }
    },
    toggleSelectAllBooks() {
      if (!this.booth || !this.booth.books) return;
      if (this.isAllBooksSelected) {
        this.selectedBookKeys = [];
      } else {
        this.selectedBookKeys = this.booth.books.map((b, idx) => this.getBookKey(b, idx));
      }
    },
    handleAddSelectedBooksToCart() {
      if (!this.booth || this.selectedBooksList.length === 0) {
        this.$toast.warning('Vui lòng chọn ít nhất một cuốn sách!');
        return;
      }

      if (this.isMyBooth) {
        this.$toast.warning('Bạn không thể tự mua sách của chính mình!');
        return;
      }

      // If user selected ALL books in the booth, add as a single COMBO/BOOTH item with combo price
      if (this.isAllBooksSelected) {
        if (this.isBoothInCart) {
          this.$toast.info(`Trọn bộ combo "${this.booth.name}" đã có trong giỏ hàng của bạn!`);
          this.$store.dispatch('cart/openDrawer');
          return;
        }

        const item = {
          id: `booth_${this.booth.id}`,
          boothId: this.booth.id,
          boothName: this.booth.name,
          sellerId: this.booth.createBy,
          sellerName: this.booth.createByName,
          saleType: this.booth.saleType,
          type: this.booth.saleType === 1 ? 'COMBO' : 'BOOTH',
          name: this.booth.name,
          cover: this.booth.stackImage || this.booth.coverImage || (this.booth.books && this.booth.books[0] && this.booth.books[0].cover),
          price: this.booth.price,
          weight: this.booth.weight || 350,
          totalBooks: this.booth.totalBooks,
          perStatus: this.booth.books && this.booth.books.length === 1 ? this.booth.books[0].perStatus : null,
          verStatus: this.booth.books && this.booth.books.length === 1 ? this.booth.books[0].verStatus : null
        };
        this.$store.dispatch('cart/addToCart', { item, openDrawer: true });
        this.$toast.success(
          this.booth.saleType === 1
            ? `Đã thêm combo "${this.booth.name}" vào giỏ hàng!`
            : `Đã thêm gian hàng "${this.booth.name}" vào giỏ hàng!`
        );
        return;
      }

      // If user selected only a subset of books, filter only books not yet in cart
      const unaddedBooks = this.selectedBooksList.filter((book, idx) => !this.isBookInCart(book, idx));
      if (unaddedBooks.length === 0) {
        this.$toast.info('Tất cả các cuốn sách bạn chọn đều đã có trong giỏ hàng!');
        this.$store.dispatch('cart/openDrawer');
        return;
      }

      const avgPrice = Math.round(this.booth.price / (this.booth.books.length || 1));
      const avgWeight = this.booth.weight ? Math.round(this.booth.weight / this.booth.books.length) : 250;
      
      const items = unaddedBooks.map((book, idx) => {
        const bookKey = this.getBookKey(book, idx);
        return {
          id: `book_${this.booth.id}_${bookKey}`,
          boothId: this.booth.id,
          boothName: this.booth.name,
          bookId: book.id || book.idBook,
          sellerId: this.booth.createBy,
          sellerName: this.booth.createByName,
          saleType: this.booth.saleType,
          type: 'SINGLE',
          name: book.name,
          author: book.author,
          cover: book.cover || book.coverBack,
          price: (this.booth.saleType === 0 && book.price) ? book.price : avgPrice,
          weight: book.weight || avgWeight,
          perStatus: book.perStatus,
          verStatus: book.verStatus
        };
      });
      this.$store.dispatch('cart/addMultipleToCart', { items, openDrawer: true });
      this.$toast.success(`Đã thêm ${items.length} cuốn sách đã chọn vào giỏ hàng!`);
    },
    openContactModal(book) {
      if (!this.isLoggedIn) {
        this.$toast.info('Vui lòng đăng nhập để đặt mua sách!');
        this.$router.push('/login');
        return;
      }
      this.selectedBookForContact = book;
      this.contactPhone = '';
      this.contactAddress = '';
      this.contactNote = '';
      this.showContactModal = true;
    },
    submitContactMessage() {
      if (!this.contactPhone.trim()) {
        this.$toast.error('Vui lòng nhập số điện thoại hoặc Zalo liên hệ!');
        return;
      }

      this.isSendingContact = true;
      // Simulate/Trigger notification or message
      setTimeout(() => {
        this.isSendingContact = false;
        this.showContactModal = false;
        this.$toast.success('Đã gửi thông tin đặt mua thành công! Người bán sẽ sớm liên hệ lại với bạn qua SĐT/Zalo.');
      }, 600);
    },
    getCoverUrl(path) {
      const defaultPlaceholder = "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f5f2ea'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23b5b0a5' font-family='sans-serif' font-size='14'%3ES%C3%A1ch%3C/text%3E%3C/svg%3E";
      if (!path || typeof path !== 'string') return defaultPlaceholder;
      if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:') || path.startsWith('blob:')) {
        return path;
      }
      if (!path.includes('/') && !path.includes('\\') && !path.includes(':')) {
        return 'data:image/jpeg;base64,' + path;
      }

      let cleanPath = path.replace(/\\/g, '/');
      if (cleanPath.includes('oldbooks/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('oldbooks/'));
      } else if (cleanPath.includes('cover/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('cover/'));
      } else if (cleanPath.includes('storge/')) {
        cleanPath = cleanPath.substring(cleanPath.indexOf('storge/'));
      }
      cleanPath = cleanPath.replace(/^[A-Za-z]:/, '').replace(/^\/+/, '');

      const apiServiceUrl = process.env.VUE_APP_API_SERVICE_URL || process.env.VUE_APP_API_URL || '';
      const apiHost = apiServiceUrl.replace(/\/api\/?$/, '').replace(/\/+$/, '');

      if (apiHost) {
        return `${apiHost}/${cleanPath}`;
      }
      return `/${cleanPath}`;
    },
    handleImageError(event) {
      if (event && event.target) {
        event.target.onerror = null;
        event.target.src = "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='160' viewBox='0 0 120 160'%3E%3Crect width='100%25' height='100%25' fill='%23f5f2ea'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23b5b0a5' font-family='sans-serif' font-size='14'%3ES%C3%A1ch%3C/text%3E%3C/svg%3E";
      }
    },
    formatPrice(price) {
      if (!price && price !== 0) return '0 VNĐ';
      return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
    },
    formatWeight(grams) {
      if (!grams || grams <= 0) return '0g';
      if (grams >= 1000) {
        return (grams / 1000).toFixed(1).replace('.0', '') + ' kg';
      }
      return grams + 'g';
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      if (dateStr.length === 14) {
        return `${dateStr.substring(6,8)}/${dateStr.substring(4,6)}/${dateStr.substring(0,4)}`;
      }
      return dateStr;
    },
    getConditionLabel(verStatus) {
      const conditions = {
        0: 'Rất mới',
        1: 'Như mới',
        2: 'Khá mới',
        3: 'Trung bình',
        4: 'Cũ'
      };
      return conditions[verStatus] || 'Khác';
    },
    getListingStatusLabel(status) {
      const statuses = {
        0: 'Đang bán',
        1: 'Đã nhận cọc',
        2: 'Đã bán',
        3: 'Tạm ngưng',
        4: 'Đã hủy'
      };
      return statuses[status] !== undefined ? statuses[status] : 'Đang bán';
    },
    clampNum(value, min, max) {
      return Math.min(Math.max(value, min), max);
    },
    maxPanForScale(scale) {
      return Math.round((scale - 1) * 600);
    },
    openZoomModal(img) {
      if (img && typeof img === 'string') {
        this.activeImage = img;
      }
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
      this.isDragging = false;
      this.toolbarHidden = false;
      this.showZoomModal = true;
    },
    closeZoomModal() {
      this.showZoomModal = false;
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
      this.isDragging = false;
      clearTimeout(this._panHideTimer);
      this.toolbarHidden = false;
    },
    applyZoom(newScale, anchorX = 0, anchorY = 0) {
      const target = this.clampNum(newScale, 0.5, 4);
      const ratio = target / this.zoomScale;
      const maxPan = this.maxPanForScale(target);
      this.zoomPanX = this.clampNum(anchorX - (anchorX - this.zoomPanX) * ratio, -maxPan, maxPan);
      this.zoomPanY = this.clampNum(anchorY - (anchorY - this.zoomPanY) * ratio, -maxPan, maxPan);
      this.zoomScale = target;
    },
    zoomIn() {
      this.applyZoom(this.zoomScale + 0.35);
    },
    zoomOut() {
      this.applyZoom(this.zoomScale - 0.35);
    },
    resetZoom() {
      this.zoomScale = 1;
      this.zoomPanX = 0;
      this.zoomPanY = 0;
      this.isDragging = false;
      this.toolbarHidden = false;
    },
    toggleDblZoom() {
      if (this.zoomScale > 1) {
        this.resetZoom();
      } else {
        this.applyZoom(2);
      }
    },
    handleWheelZoom(e) {
      if (!this.showZoomModal) return;
      const stage = this.$refs.zoomStage;
      let anchorX = 0;
      let anchorY = 0;
      if (stage) {
        const rect = stage.getBoundingClientRect();
        anchorX = e.clientX - rect.left - rect.width / 2;
        anchorY = e.clientY - rect.top - rect.height / 2;
      }
      this.applyZoom(this.zoomScale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), anchorX, anchorY);
    },
    handleZoomKeydown(e) {
      if (!this.showZoomModal) return;
      const panStep = 40;
      if (e.key === 'Escape' || e.key === 'Esc') {
        this.closeZoomModal();
        return;
      }
      if (e.key === '+' || e.key === '=') {
        e.preventDefault();
        this.zoomIn();
        return;
      }
      if (e.key === '-' || e.key === '_') {
        e.preventDefault();
        this.zoomOut();
        return;
      }
      if (e.key === '0') {
        this.resetZoom();
        return;
      }
      if (this.zoomScale <= 1) return;
      const maxPan = this.maxPanForScale(this.zoomScale);
      this.toolbarHidden = true;
      clearTimeout(this._panHideTimer);
      this._panHideTimer = setTimeout(() => { this.toolbarHidden = false; }, 700);
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.zoomPanY = this.clampNum(this.zoomPanY - panStep, -maxPan, maxPan);
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.zoomPanY = this.clampNum(this.zoomPanY + panStep, -maxPan, maxPan);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.zoomPanX = this.clampNum(this.zoomPanX - panStep, -maxPan, maxPan);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.zoomPanX = this.clampNum(this.zoomPanX + panStep, -maxPan, maxPan);
      }
    },
    startDrag(e) {
      if (this.zoomScale <= 1) return;
      if (e.button !== 0) return;
      e.preventDefault();
      this.isDragging = true;
      this.toolbarHidden = true;
      this.dragStartX = e.clientX - this.zoomPanX;
      this.dragStartY = e.clientY - this.zoomPanY;
    },
    onDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const maxPan = this.maxPanForScale(this.zoomScale);
      this._dragNextX = this.clampNum(e.clientX - this.dragStartX, -maxPan, maxPan);
      this._dragNextY = this.clampNum(e.clientY - this.dragStartY, -maxPan, maxPan);
      if (this._dragRaf) return;
      this._dragRaf = requestAnimationFrame(() => {
        this._dragRaf = null;
        this.zoomPanX = this._dragNextX;
        this.zoomPanY = this._dragNextY;
      });
    },
    stopDrag() {
      this.isDragging = false;
      if (this._dragRaf) {
        cancelAnimationFrame(this._dragRaf);
        this._dragRaf = null;
        this.zoomPanX = this._dragNextX;
        this.zoomPanY = this._dragNextY;
      }
      this.toolbarHidden = false;
    }
  }
};
